import Icon from '../Icon';

const Demo6Features4 = () => {
    return (
        <section id="features-4" className="pb-60 features-section division">
            <div className="container">
                <div className="fbox-4-wrapper">
                    <div className="row row-cols-1 row-cols-md-2">
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🖥️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Friendly Interface</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="⚙️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Powerful Options</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🗂️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">File Manager</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🎞️" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Convert Media Files</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="fbox-ico-center ico-65">
                                        <Icon symbol="🔗" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Files Sharing</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-4 pc-25 mb-40 wow fadeInUp">
                                <div className="fbox-ico">
                                    <div className="ico-65">
                                        <Icon symbol="➕" decorative className="feature-icon" />
                                    </div>
                                </div>
                                <div className="fbox-txt">
                                    <h5 className="h5-md">Extensions &amp; Addons</h5>
                                    <p className="p-lg">
                                        Porta semper lacus cursus feugiat primis ultrice ligula risus at auctor tempus feugiat impedit felis undo auctor augue mauris
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Features4;
